import loadable from '@loadable/component';

export default {
	home: {
		path: '/',
		exact: true,
		layout: 'base',
		layoutClass: 'home',
		forceSSR: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/home')),
	},
	notFound: {
		path: '*',
		layout: 'raw',
		layoutClass: 'error type-not-found',
		status: 404,
		head: {
			title: 'Sayfa Bulunamadı',
		},
		component: loadable(() => import('/views/pages/not-found')),
	},
	error: {
		path: '*',
		layout: 'raw',
		layoutClass: 'error type-error',
		status: 500,
		head: {
			title: 'Bir Hata İle Karşılaşıldı',
		},
		component: loadable(() => import('/views/pages/error')),
	},
};
